import { debugLog } from 'shared/logger/debugLog';
import { LogLevel } from 'shared/types/logger';
import { appLog } from './appLog';
import { provideLogInfo } from './provideLogInfo';

export const logError = (
  message: string,
  errorObjectWithPotentiallySensitiveData?: any,
  addTimestamp?: boolean
): void => {
  const additionalInfo = provideLogInfo();
  const dataWithTimestamp = addTimestamp
    ? {
        ...(errorObjectWithPotentiallySensitiveData || {}),
        timestamp: new Date().toISOString(),
      }
    : errorObjectWithPotentiallySensitiveData;
  debugLog(
    message,
    LogLevel.ERROR,
    additionalInfo,
    dataWithTimestamp
  );
  appLog(
    message,
    LogLevel.ERROR,
    additionalInfo,
    dataWithTimestamp
  );
};
